import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { checkOverflowLeft, checkOverflowRight } from './tableUtils';
import Spinner from '../Loaders/Spinner';

interface TableProps {
  id: string;
  tableHead: React.ReactElement;
  tableBody: React.ReactElement;
  isLoading: boolean;
  loader: React.ReactElement;
}

function Table({
  id, tableHead, tableBody, isLoading, loader,
}: TableProps) {
  const tableRef = useRef(null);
  const wrapperRef = useRef(null);
  const [isOverflowRight, setIsOverflowRight] = useState(false);
  const [isOverflowLeft, setIsOverflowLeft] = useState(false);

  const onScroll = () => {
    if (
      tableRef.current
      && wrapperRef.current
    ) {
      setIsOverflowRight(checkOverflowRight(wrapperRef.current, tableRef.current));
      setIsOverflowLeft(checkOverflowLeft(wrapperRef.current, tableRef.current));
    }
  };

  useEffect(() => {
    onScroll();
  });
  return (
    <>
      <div className="common__table_overflow">
        {isOverflowRight && <div className="overflow-right" />}
        {isOverflowLeft && <div className="overflow-left" />}
        <div
          id={id}
          className="common__table_wrapper"
          ref={wrapperRef}
          onScroll={onScroll}
        >
          <table className={`${isLoading && 'loading'}`} ref={tableRef}>
            {React.cloneElement(tableHead)}
            {React.cloneElement(tableBody)}
          </table>
        </div>
      </div>
      {isLoading && (
      <div className="loader_container">{React.cloneElement(loader)}</div>
      )}
    </>
  );
}

Table.defaultProps = {
  id: '',
  loader: <Spinner />,
};

Table.propTypes = {
  id: PropTypes.string,
  tableHead: PropTypes.object.isRequired,
  tableBody: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loader: PropTypes.element,
};

export default Table;
